<template>
    <el-dialog
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="40%"
        title="用户导入"
        :visible.sync="visible"
        :lock-scroll="false">
        <el-descriptions
            title=""
            :column="1"
            style="padding:0 70px 0 70px;">
            <el-descriptions-item label="所属用户组" v-if="typeof organLeverData !== 'undefined'">
                <el-cascader :options="organLeverData"
                             size="small"
                             v-model="OrganLevelId" :props="{ checkStrictly: true, emitPath: false }"/>
            </el-descriptions-item>
            <el-descriptions-item label="导入字段" style="color:#333;">
                模板中的：用户名、密码、真实姓名、用户组织编码为必填字段；其余字段（身份证、学号、电话、email、性别、简介等）根据实际情况自行填写；
            </el-descriptions-item>
            <el-descriptions-item label="用  户 名">同一机构下的用户，用户名必须唯一，存在重复用户名将无法导入；
            </el-descriptions-item>
            <el-descriptions-item label="模板下载">
                <a
                    :href="$store.state.protocol + '//fmh.cqvip.com/download/6c86042efa3d4368b809dd7c06febbc4.xls'"
                    download="用户模板"
                    style="text-decoration: none;color:#f00"><i
                    class="el-icon-download"
                    style="margin:0 5px"></i>用户导入Excel模板</a></el-descriptions-item>
            <el-descriptions-item label="模板导入">
                <el-button
                    icon="el-icon-upload2"
                    type="primary"
                    size="small"
                    @click.stop="importUser">导入用户
                </el-button>
            </el-descriptions-item>
        </el-descriptions>
    </el-dialog>
</template>

<script>
import { uploadOfInput } from "@/utils";
import { uploadFile } from "@/api/manage";
import { importUser } from "@/api/user";
export default {
    name: "userImport",
    props: {
        organLeverData: {
            type: Array
        }
    },
    data () {
        return {
            visible: false,
            OrganLevelId: undefined
        }
    },
    mounted() {
        // this.GetOrganLevelInfo()
    },
    methods: {
        open () {
            this.visible = true
        },
        close () {
            this.visible = false
        },
        // 导入用户
        importUser () {
            uploadOfInput((file) => {
                if (!file) return
                const loading = this.$loading({
                    lock: true,
                    text: "导入中",
                    background: "rgba(0, 0, 0, .2)"
                });
                uploadFile({ file }).then(res => {
                    importUser(res).then(file => {
                        this.$message.success("导入成功")
                        this.$emit("updateList")
                        loading.close()
                        this.close()
                    }).catch(e => {
                        loading.close()
                    })
                }).catch(e => {
                    loading.close()
                })
            }, () => {
                this.$message.error("选择文件失败")
            }, ".xls,.xlsm,.xlsx,.xlsb")
        }
    }
}
</script>

<style scoped>

</style>
